import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

const FooterTwo = () => {
  const { t } = useTranslation();
  const { token } = useSelector((state) => state.auth);

  return (
    <footer className="footer pt-80 pb-40 bg-white mt-40">
      <div className="container container-lg">
        <div className="row">
          <div className="col-lg-3 footerMargin">
            <div className="footer-item">
              <div className="footer-item__logo">
                <Link to="/">
                  <img src="/assets/images/logo/colour.png" className="w-100" alt={t("logoAlt")} />
                </Link>
              </div>
              <p className="mb-24">{t("footerDescription")}</p>
              <ul className="flex-align gap-16">
                <li>
                  <Link
                    to="https://www.facebook.com/argetam"
                    className="w-44 h-44 flex-center text-xl rounded-8 bg-main-two-600 text-white"
                  >
                    <i className="ph-fill ph-facebook-logo" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="/https://www.twitter.com"
                    className="w-44 h-44 flex-center text-xl rounded-8 bg-main-two-600 text-white"
                  >
                    <i className="ph-fill ph-twitter-logo" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.instagram.com/argetam_official/"
                    className="w-44 h-44 flex-center text-xl rounded-8 bg-main-two-600 text-white"
                  >
                    <i className="ph-fill ph-instagram-logo" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.youtube.com/channel/UCKM8J8hkGoHpmZYttVHXI7w"
                    className="w-44 h-44 flex-center text-xl rounded-8 bg-main-two-600 text-white"
                  >
                    <i className="ph-fill ph-youtube-logo" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="footer-item">
              <h6 className="footer-item__title">{t("argetam")}</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link to="/pricing-plan" className="text-gray-600 hover-text-main-600">
                    {t("plans.title")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/shops" className="text-gray-600 hover-text-main-600">
                    {t("argetamShops")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/products" className="text-gray-600 hover-text-main-600">
                    {t("products")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/user-register" className="text-gray-600 hover-text-main-600">
                    {t("signUp")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/user-login" className="text-gray-600 hover-text-main-600">
                    {t("signIn")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="footer-item">
              <h6 className="footer-item__title">{t("support")}</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link to="/contact" className="text-gray-600 hover-text-main-600">
                    {t("contactUs")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/privacy" className="text-gray-600 hover-text-main-600">
                    {t("privacyPolicy")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/terms" className="text-gray-600 hover-text-main-600">
                    {t("termsConditions")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/seller-policies" className="text-gray-600 hover-text-main-600">
                    {t("sellerPolicies")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/user-policies" className="text-gray-600 hover-text-main-600">
                    {t("userPolicies")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="footer-item">
              <h6 className="footer-item__title">{t("accounts")}</h6>
              <ul className="footer-menu">
                <li className="mb-16">
                  <Link 
                    to={token ? "/dashboard/wishlist" : "/user-login"} 
                    className="text-gray-600 hover-text-main-600"
                  >
                    {t("wishlists")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to={token ? "/dashboard/order" : "/user-login"} className="text-gray-600 hover-text-main-600">
                    {t("myOrders")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to={token ? "/cart" : "/cart"} className="text-gray-600 hover-text-main-600">
                    {t("shoppingCart")}
                  </Link>
                </li>
                <li className="mb-16">
                  <Link to="/seller-register" className="text-gray-600 hover-text-main-600">
                    {t("becomeASeller")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="footer-item">
              <h6 className="">{t("getItNow")}</h6>
              <div className="flex-align gap-8 my-22">
                <Link to="/https://www.apple.com/store" className="">
                  <img src="/assets/images/apple.png" alt="" />
                </Link>
                <Link to="/https://play.google.com/store/apps?hl=en" className="">
                  <img src="/assets/images/google.png" alt="" />
                </Link>
              </div>
              <div className="flex-align gap-16 mb-14">
                <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                  <i className="ph-fill ph-phone-call" />
                </span>
                <Link to="/tel:+00123456789" className="text-md text-gray-900 hover-text-main-600">
                  +00 123 456 789
                </Link>
              </div>
              <div className="flex-align gap-16 mb-14">
                <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                  <i className="ph-fill ph-envelope" />
                </span>
                <Link to="/mailto:info@argetam.com" className="text-md text-gray-900 hover-text-main-600">
                  info@argetam.com
                </Link>
              </div>
              <div className="flex-align gap-16 mb-14">
                <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                  <i className="ph-fill ph-map-pin" />
                </span>
                <span className="text-md text-gray-900 ">789 Inner Lane, California, USA</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
